import { Indicator } from '@artprov/design-system';
import PropTypes from "prop-types";
import { gridColsMap } from "../layouts/gridColsMap";

/**
 * Grid de indicadores reutilizable.
 * Recibe una configuración dinámica de indicadores y las estadísticas.
 * Si no se especifica `columns`, usa un grid responsive automático que se adapta
 * a cualquier cantidad de indicadores sin romper el layout.
 */
export function IndicadoresGrid({
    config,
    estadisticas,
    columns,
    className = ""
}) {
    const resolvedColumns = columns ?? config.length;
    const gridColsClass =
        gridColsMap[resolvedColumns] ?? "grid-cols-[repeat(auto-fill,minmax(160px,1fr))]";

    return (
        <div
            className={[
                "grid gap-x-4 gap-y-2 w-full mt-2 mb-4",
                gridColsClass,
                className
            ].join(" ")}
        >
            {config.map(({ key, text, icon }) => (
                <Indicator
                    key={key}
                    title={String(estadisticas?.[key] ?? 0)}
                    text={text}
                    icon={icon}
                    variant="large"
                />
            ))}
        </div>
    );
}

IndicadoresGrid.propTypes = {
    config: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
        })
    ).isRequired,
    estadisticas: PropTypes.object,
    columns: PropTypes.number,
    className: PropTypes.string
};
